import { PageRouteBuilder } from "@common/route/page-route-builder";
import { McpConsentPageComponent } from "./mcp-consent-page.component";

export const mcpConsentPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-mcp-consent-page", McpConsentPageComponent)
    .atUrl("/account/mcp-consent")
    .withTitle("Connect an app")
    .requiresLogin()
    .build();
